export const ExpressionType_Score = { dbKey: 'score', label: 'Score' };
export const ExpressionType_ClinicalFunction = { dbKey: 'clinical-function', label: 'Clinical Function' };
export const ExpressionType_ResolutionFunction = {
    dbKey: 'resolution-function',
    label: 'Resolution Function'
};
export const ExpressionType_NormalRange = { dbKey: 'normal-range', label: 'Normal Range' };
export const ExpressionType_GeneralFunction = { dbKey: 'general-function', label: 'General Function' };
export const ExpressionType_GeneralScore = { dbKey: 'general-score', label: 'General Score' };
export const ExpressionType_InRange = { dbKey: 'in-range', label: 'In Range' };
export const ExpressionType_Deduction = { dbKey: 'deduction', label: 'Deduction' };
export const ExpressionTypesWithVariable = [ExpressionType_ClinicalFunction.dbKey, ExpressionType_Score.dbKey, ExpressionType_NormalRange.dbKey];
export const BuilderExpressionTypes = [ExpressionType_ClinicalFunction,
    ExpressionType_Score,
    ExpressionType_GeneralFunction,
    ExpressionType_GeneralScore,
    ExpressionType_Deduction];
export const AllExpressionTypes = [...BuilderExpressionTypes, ExpressionType_NormalRange, ExpressionType_ResolutionFunction, ExpressionType_InRange];
export const booleanExpressionTypes = [ExpressionType_ClinicalFunction.dbKey, ExpressionType_GeneralFunction.dbKey, ExpressionType_InRange.dbKey];
export const numericExpressionTypes = [ExpressionType_GeneralScore.dbKey, ExpressionType_Score.dbKey];
export const rangeExpressionTypes = [ExpressionType_NormalRange.dbKey];
export const noVarExpressionTypes = [
    ExpressionType_ResolutionFunction.dbKey,
    ExpressionType_GeneralFunction.dbKey,
    ExpressionType_GeneralScore.dbKey,
    ExpressionType_Deduction.dbKey
];
export const BuilderTypesDbKeys = BuilderExpressionTypes.map(type => type.dbKey);
export const LabType_BelowRange = 'Below Range';
export const LabType_AboveRange = 'Above Range';
export const LabType_InRange = 'In Range';
export const labsExpressionTitles = [LabType_InRange, LabType_AboveRange, LabType_BelowRange];
export const ExpressionOutput_Range = 'range';
export const ExpressionOutput_Numeric = 'numeric';
export const ExpressionOutput_Boolean = 'boolean';
//# sourceMappingURL=consts.js.map